import styled from '@emotion/styled';
import { Component } from 'react';

const Header = styled.div`
  align-items: center;
  display: flex;
  padding: 1em;
  position: relative;
  width: 100%;
`;

const OCLogo = styled.span`
  background-image: url(https://d10dvh97d9q6kg.cloudfront.net/static/images/oc-logo.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  display: inline-block;
  height: 4.5em;
  margin-right: 0.75em;
  position: relative;
  width: 4.5em;

  @media (max-width: 1050px) {
    height: 4em;
    width: 4em;
  }

  @media (max-width: 768px) {
    height: 3.5em;
    width: 3.5em;
  }
`;

const Title = styled.span`
  color: #000000;
  display: inline-block;
  font-size: 2.143em;
  font-weight: 300;
  line-height: 120%;
  position: relative;

  @media (max-width: 1050px) {
    font-size: 1.75em;
  }

  @media (max-width: 768px) {
    font-size: 1.571em;
  }
`;

export default class WidgetHeader extends Component {
  render() {
    return (
      <Header>
        <OCLogo className={this.props.OCLogo} />
        <Title className={this.props.titleStyle}>{this.props.title}</Title>
      </Header>
    );
  }
}
